import React from 'react'
import { useTimeTableMonth } from '../../state/storeTimeTable';
import { useConditional } from '../../state/storeConditional ';


const LanguageHijra = () => {
    const {updateIsOnChangeInHijra} = useConditional()

    const {updateHijraLocale,HijraLocale } = useTimeTableMonth();

    return (
        <fieldset className='m-2'>
            <legend>Select a Language Hijra:</legend>

            <div className='m-2'>
                <input className='m-2' type="radio" id="ar" name="lan" value="ar-SA" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"ar-SA",customLan:false})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "ar-SA"} />
                <label htmlFor="ar">Arabic</label>
            </div>

            <div className='m-2'>
                <input className='m-2' type="radio" id="en" name="lan" value="en-US" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"en-US",customLan:false})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "en-US"} />
                <label htmlFor="en">English</label>
            </div>
            <div className='m-2'>
                <input className='m-2' type="radio" id="es" name="lan" value="es-ES" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"es-ES",customLan:false})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "es-ES"} />
                <label htmlFor="es">Spanish Spain</label>
            </div>
            <div className='m-2'>
                <input className='m-2' type="radio" id="tk" name="lan" value="tr-TR" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"tr-TR",customLan:false})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "tr-TR"} />
                <label htmlFor="tk">Turkish</label>
            </div>
            <div className='m-2'>
                <input className='m-2' type="radio" id="in" name="lan" value="hi-IN" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"hi-IN",customLan:false})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "hi-IN"} />
                <label htmlFor="in">India</label>
            </div>
            <div className='m-2'>
                <input className='m-2' type="radio" id="custom" name="lan" value="en-GB" onChange={() => {
                    updateHijraLocale({...HijraLocale,lan:"en-GB",customLan:true})
                    updateIsOnChangeInHijra(true)
                    }} defaultChecked={HijraLocale.lan === "en-GB"} />
                <label htmlFor="custom">Custom Langauge</label>
            </div>
            
        </fieldset>
    )
}

export default LanguageHijra